export default {
  title: 'Detalii comandă',
};
